<template>
    <header class="au-topbar">
        <nav class="au-crumb" aria-label="breadcrumb">
            <router-link :to="{ name: 'Dashboard' }" :title="$t('nav.home')" :aria-label="$t('nav.home')">
                <i class="bi bi-house-door"></i>
            </router-link>
            <i class="bi bi-chevron-right" style="font-size: 11px;"></i>
            <strong>{{ pageTitle }}</strong>
        </nav>
        <div class="ms-auto">
            <LanguageSwitch />
        </div>
    </header>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import LanguageSwitch from "@/components/LanguageSwitch.vue";

export default defineComponent({
    components: { LanguageSwitch },
    setup() {
        const route = useRoute();
        const { t } = useI18n();
        const pageTitle = computed(() => {
            const key = route.meta.titleKey as string | undefined;
            return key ? t(key) : "";
        });
        return { pageTitle };
    },
});
</script>
